import is from '@sindresorhus/is';
import { decode, encodeURL } from 'js-base64';
import { useContext } from 'react';
import { z } from 'zod';

import { sortOptionSchema } from './sort-option';
import { ApplicationContext } from '../../../../../shared/source/context/context';

import type { SortOption } from './sort-option';

type SaveSortOptions = (sort: readonly SortOption[]) => void;

const sortParameterSchema = z
    .string()
    .nullable()
    .transform((sort) => {
        if (is.nullOrUndefined(sort)) {
            return [];
        }

        try {
            return sortOptionSchema.array().parse(JSON.parse(decode(sort)));
        } catch {
            return [];
        }
    });

export const usePersistTableSort = (sortQueryParamName: string): readonly [readonly SortOption[], SaveSortOptions] => {
    const { actions, applicationState } = useContext(ApplicationContext);
    const sortOptions = sortParameterSchema.parse(applicationState.locationSearchParams.get(sortQueryParamName));

    const saveSortOptions: SaveSortOptions = (sort) => {
        if (is.nonEmptyArray(sort)) {
            applicationState.locationSearchParams.set(sortQueryParamName, encodeURL(JSON.stringify(sort)));
            actions.setLocationSearchParams(applicationState.locationSearchParams);

            return;
        }

        actions.deleteLocationSearchParams([sortQueryParamName]);
    };

    return [sortOptions, saveSortOptions];
};
